var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconSearchConversation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3333 22.3346L20.6667 20.668M21.5 13.5846C21.5 17.9569 17.9556 21.5013 13.5833 21.5013C9.21107 21.5013 5.66666 17.9569 5.66666 13.5846C5.66666 9.21238 9.21107 5.66797 13.5833 5.66797C17.9556 5.66797 21.5 9.21238 21.5 13.5846Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconSearchConversation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-search-conversation.4eee2a91ac05c51287d27a89bf405424.svg";